export default __webpack_public_path__ + "static/media/bg9.6464a978.png";